import { useLocation } from "react-router";

import { resolveAuthRedirectUrl } from "~/feature/auth/utils/resolveAuthRedirectUrl";

export const useAuthRedirectUrl = (): string => {
  const { pathname } = useLocation();

  return resolveAuthRedirectUrl(pathname, window.location.href);
};
